var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"error","x-small":"","depressed":"","loading":_vm.loading},on:{"click":function($event){return _vm.deleteRole(_vm.role)}}},[_vm._v("Delete")])
}
var staticRenderFns = []

export { render, staticRenderFns }